export default {"src":"/_next/static/image/public/images/ic_close_grey.30563f3ae5d5f3978b0f7e456872be1c.svg","height":20,"width":20};